export const lightThemeColors = {
  background: {
    active: '#E8EDF3',
    primary: '#ffffff',
    secondary: '#F9F9F9',
    overlay: '#0000007D',
    success: '#16C784',
    hover: 'rgba(0, 0, 0, 0.08)',
  },

  positionRange: {
    success: {
      background: '#16C784',
      border: '#0F5C45',
    },
    danger2: {
      background: '#F1C21B',
      border: '#B49119',
    },
    danger1: {
      background: '#FF832B',
      border: '#CC5F1E',
    },
    danger: {
      background: '#F04949',
      border: '#8B0000',
    },
  },

  alerts: {
    warning: {
      background: '#fff4b3',
      border: '#f1c21b',
      color: '#5c4b00',
    },
    error: {
      background: '#fdeaea',
      border: '#F04949',
      color: '#7a1f1f',
    },
    success: {
      background: '#e6f7f1',
      border: '#16C784',
      color: '#0a4f3b',
    },
  },

  text: {
    primary: '#043754',
    active: '#539ACE',
    activeTransparent: 'rgba(83, 154, 206, 0.10)',
    primaryDark: '#000000',
    primaryDarkBackground: '#fff',
    primaryStatusBg: '#fff',
    secondary: '#585858',
    description: '#95949A',
    disabled: '#757575',
    info: '#666',
    danger: '#F04949',
    danger1: '#ff832b',
    danger2: '#f1c21b',
    success: '#16C784',
    create: '#2775CA',
    successLabelBg: 'rgba(22, 199, 132, 0.10)',
    dangerLabelBg: 'rgba(240, 73, 73, 0.10)',
    danger2LabelBg: '#fdf6e3',
    createLabelBg: 'rgba(39, 117, 202, 0.10)',
  },

  metricsGraph: {
    option1: '#043754',
    option2: '#f1c21b',
    option3: '#16C784',
    option4: '#F04949',
  },

  button: {
    background: '#043754',
    text: '#fff',
    hover: '#06597A',
    outlinedBoxShadow: 'rgba(0, 0, 0, 0.15)',
    lightBackground: '#d1ebfe',
    lightBackgroundText: '#043754',
  },

  accordion: {
    header: '#E4E4E4',
    headerHover: '#E8E8E8',
    body: '#FDFDFD',
    border: '#F5F5F5',
  },

  divider: '#DCDDDD',
  border: '#e9e9e9',

  gradients: {
    pageBackgroundGradient:
      'linear-gradient(to bottom, white 35%, #fef8ee 60%, white 80%, #ebf8ff 100%);',
  },

  disabledSlider: 'rgba(83, 154, 206, 0.1)',

  dialog: {
    titleBorder: '#ccc',
    overlay: 'rgba(0, 0, 0, 0.5)',
  },

  menu: {
    boxShadow: 'rgba(0, 0, 0, 0.12)',
  },

  header: {
    scrolled: 'rgba(255, 228, 169, 0.32)',
  },

  input: {
    placeholder: 'rgba(4, 55, 84, 0.4)',
  },

  carousel: {
    navButtonBg: 'rgba(255, 255, 255, 0.8)',
    navButtonBgHover: 'rgba(255, 255, 255, 1)',
  },

  contentLoader: {
    backgroundColor: '#f3f3f3',
    foregroundColor: '#ecebeb',
  },

  coinContainerBg: '#f7fcfe',

  listHeaderBorder: '#a9d0ee',

  inactiveTab: '#D1EBFE',

  rangePicker: {
    white: '#ffffff',
    black: '#000000',
    neutral1: '#222222',
    neutral2: '#7D7D7D',
    neutral3: '#CECECE',
    surface1: '#FFFFFF',
    surface2: '#F9F9F9',
    surface3: '#22222212',
    accent1: '#043754',
    accent3: '#4C82FB',
    // token0: '#043754',
    // token1: '#4C82FB',
    success: '#40B66B',
    critical: '#FF5F52',
  },
}

export const darkThemeColors = {
  background: {
    active: '#20272D',
    primary: '#14191D',
    secondary: '#1B2026',
    overlay: 'rgba(0, 0, 0, 0.9)',
    success: '#16C784',
    hover: 'rgba(255, 255, 255, 0.08)',
  },

  metricsGraph: {
    option1: '#78E2FF',
    option2: '#F1C21B',
    option3: '#16C784',
    option4: '#F04949',
  },

  positionRange: {
    success: {
      border: '#16C784',
      background: '#0F5C45',
    },
    danger2: {
      border: '#F1C21B',
      background: '#B49119',
    },
    danger1: {
      border: '#FF832B',
      background: '#CC5F1E',
    },
    danger: {
      border: '#F04949',
      background: '#8B0000',
    },
  },
  alerts: {
    warning: {
      background: '#4b3f00',
      border: '#f1c21b',
      color: '#ffe08a',
    },
    error: {
      background: '#4d1c1c',
      border: '#F04949',
      color: '#ffb3b3',
    },
    success: {
      background: '#0f3b2e',
      border: '#16C784',
      color: '#a0f0d0',
    },
  },

  text: {
    primary: '#F0F4FA',
    active: '#78E2FF',
    activeTransparent: 'rgba(120, 226, 255, 0.1)',
    primaryDark: '#FFFFFF',
    primaryDarkBackground: '#14191D',
    primaryStatusBg: '#fff',
    secondary: '#B6BAC0',
    description: '#8A9097',
    disabled: '#5C616B',
    info: '#78E2FF',
    danger: '#F04949',
    danger1: '#FF832B',
    danger2: '#F1C21B',
    success: '#16C784',
    create: '#78E2FF',
    successLabelBg: 'rgba(22, 199, 132, 0.1)',
    dangerLabelBg: 'rgba(240, 73, 73, 0.1)',
    danger2LabelBg: '#FDF6E3',
    createLabelBg: 'rgba(120, 226, 255, 0.1)',
  },

  button: {
    background: '#78E2FF',
    text: '#14191D',
    hover: '#90ECFF',
    outlinedBoxShadow: 'rgba(120, 226, 255, 0.3)',
    lightBackground: '#90ECFF',
    lightBackgroundText: '#043754',
  },

  accordion: {
    header: '#272D34',
    headerHover: '#30363E',
    body: '#20272D',
    border: '#333940',
  },

  divider: '#3F454D',
  border: '#464C54',

  gradients: {
    pageBackgroundGradient: 'linear-gradient(to bottom, #14191D 20%, #1F262D 50%, #1B2026 80%)',
  },

  disabledSlider: 'rgba(120, 226, 255, 0.1)',

  dialog: {
    titleBorder: '#4C535C',
    overlay: 'rgba(0, 0, 0, 0.92)',
  },

  menu: {
    boxShadow: 'rgba(0, 0, 0, 0.65)',
  },

  header: {
    scrolled: 'rgba(32, 39, 45, 0.5)',
  },

  input: {
    placeholder: 'rgba(240, 244, 250, 0.3)',
  },

  carousel: {
    navButtonBg: 'rgba(40, 46, 54, 0.8)',
    navButtonBgHover: 'rgba(40, 46, 54, 1)',
  },

  contentLoader: {
    backgroundColor: '#2E353D',
    foregroundColor: '#40454C',
  },

  coinContainerBg: '#272C32',

  listHeaderBorder: '#535960',

  inactiveTab: '#3A4048',

  rangePicker: {
    white: '#ffffff',
    black: '#000000',
    neutral1: '#FFFFFF',
    neutral2: '#9B9B9B',
    neutral3: '#5E5E5E',
    surface1: '#131313',
    surface2: '#1B1B1B',
    surface3: '#FFFFFF12',
    accent1: '#78E2FF',
    accent3: '#4C82FB',
    // token0: '#78E2FF',
    // token1: '#4C82FB',
    success: '#40B66B',
    critical: '#FF5F52',
  },
}
